module.exports = __webpack_public_path__ + "static/img/bugeyes.ac1f67f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/bugeyes.jpg
// module id = tnMU
// module chunks = 1